var _switch;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#00df94",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#00df94",
    d: "M80.8,12.1h-5v-3c0-3.7-3-6.6-6.6-6.6c-3.7,0-6.6,3-6.6,6.6v3H37.5v-3c0-3.7-3-6.6-6.6-6.6c-3.7,0-6.6,3-6.6,6.6v3h-5     c-5.2,0-9.4,4.2-9.4,9.4v66.6c0,5.2,4.2,9.4,9.4,9.4h61.5c5.2,0,9.4-4.2,9.4-9.4V21.5C90.2,16.3,86,12.1,80.8,12.1z M13.8,79.8     c1.5,1.1,3.4,1.8,5.5,1.8h61.5c2,0,3.9-0.7,5.4-1.7v0.3c0,3-2.4,5.4-5.4,5.4H19.3c-3,0-5.5-2.4-5.5-5.4V79.8z M86.2,72.1     c0,3-2.4,5.4-5.4,5.4H19.3c-3,0-5.5-2.4-5.5-5.4V30.4h72.4V72.1z M66.5,9.1c0-1.5,1.2-2.6,2.6-2.6s2.6,1.2,2.6,2.6v6.2     c0,1.5-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6V9.1z M28.3,9.1c0-1.5,1.2-2.6,2.6-2.6s2.6,1.2,2.6,2.6v6.2c0,1.5-1.2,2.6-2.6,2.6     s-2.6-1.2-2.6-2.6V9.1z M19.3,16.1h5.1c0.4,3.3,3.2,5.9,6.6,5.9c3.4,0,6.2-2.6,6.6-5.9h25.1c0.4,3.3,3.2,5.9,6.6,5.9     c3.4,0,6.2-2.6,6.6-5.9h5.1c3,0,5.4,2.4,5.4,5.4v4.9H13.8v-4.9C13.8,18.5,16.2,16.1,19.3,16.1z M80.8,93.5H19.3     c-3,0-5.5-2.4-5.5-5.4v-0.3c1.5,1.1,3.4,1.8,5.5,1.8h61.5c2,0,3.9-0.7,5.4-1.7v0.3C86.2,91.1,83.8,93.5,80.8,93.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00df94",
    d: "M25.1,57.2h0.3c1.7,0,3.1-1.4,3.1-3.1v-0.3c0-1.7-1.4-3.1-3.1-3.1h-0.3c-1.7,0-3.1,1.4-3.1,3.1v0.3     C22,55.9,23.4,57.2,25.1,57.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00df94",
    d: "M37.5,57.2h0.3c1.7,0,3.1-1.4,3.1-3.1v-0.3c0-1.7-1.4-3.1-3.1-3.1h-0.3c-1.7,0-3.1,1.4-3.1,3.1v0.3     C34.4,55.9,35.8,57.2,37.5,57.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00df94",
    d: "M49.9,57.2h0.3c1.7,0,3.1-1.4,3.1-3.1v-0.3c0-1.7-1.4-3.1-3.1-3.1h-0.3c-1.7,0-3.1,1.4-3.1,3.1v0.3     C46.8,55.9,48.2,57.2,49.9,57.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00df94",
    d: "M25.1,44.8h0.3c1.7,0,3.1-1.4,3.1-3.1v-0.3c0-1.7-1.4-3.1-3.1-3.1h-0.3c-1.7,0-3.1,1.4-3.1,3.1v0.3     C22,43.4,23.4,44.8,25.1,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00df94",
    d: "M37.5,44.8h0.3c1.7,0,3.1-1.4,3.1-3.1v-0.3c0-1.7-1.4-3.1-3.1-3.1h-0.3c-1.7,0-3.1,1.4-3.1,3.1v0.3     C34.4,43.4,35.8,44.8,37.5,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00df94",
    d: "M49.9,44.8h0.3c1.7,0,3.1-1.4,3.1-3.1v-0.3c0-1.7-1.4-3.1-3.1-3.1h-0.3c-1.7,0-3.1,1.4-3.1,3.1v0.3     C46.8,43.4,48.2,44.8,49.9,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00df94",
    d: "M62.3,57.2h0.3c1.7,0,3.1-1.4,3.1-3.1v-0.3c0-1.7-1.4-3.1-3.1-3.1h-0.3c-1.7,0-3.1,1.4-3.1,3.1v0.3     C59.2,55.9,60.6,57.2,62.3,57.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00df94",
    d: "M74.7,57.2H75c1.7,0,3.1-1.4,3.1-3.1v-0.3c0-1.7-1.4-3.1-3.1-3.1h-0.3c-1.7,0-3.1,1.4-3.1,3.1v0.3     C71.6,55.9,73,57.2,74.7,57.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00df94",
    d: "M62.3,44.8h0.3c1.7,0,3.1-1.4,3.1-3.1v-0.3c0-1.7-1.4-3.1-3.1-3.1h-0.3c-1.7,0-3.1,1.4-3.1,3.1v0.3     C59.2,43.4,60.6,44.8,62.3,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00df94",
    d: "M74.7,44.8H75c1.7,0,3.1-1.4,3.1-3.1v-0.3c0-1.7-1.4-3.1-3.1-3.1h-0.3c-1.7,0-3.1,1.4-3.1,3.1v0.3     C71.6,43.4,73,44.8,74.7,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00df94",
    d: "M25.1,69.7h0.3c1.7,0,3.1-1.4,3.1-3.1v-0.3c0-1.7-1.4-3.1-3.1-3.1h-0.3c-1.7,0-3.1,1.4-3.1,3.1v0.3     C22,68.3,23.4,69.7,25.1,69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00df94",
    d: "M37.5,69.7h0.3c1.7,0,3.1-1.4,3.1-3.1v-0.3c0-1.7-1.4-3.1-3.1-3.1h-0.3c-1.7,0-3.1,1.4-3.1,3.1v0.3     C34.4,68.3,35.8,69.7,37.5,69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00df94",
    d: "M49.9,69.7h0.3c1.7,0,3.1-1.4,3.1-3.1v-0.3c0-1.7-1.4-3.1-3.1-3.1h-0.3c-1.7,0-3.1,1.4-3.1,3.1v0.3     C46.8,68.3,48.2,69.7,49.9,69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00df94",
    d: "M62.3,69.7h0.3c1.7,0,3.1-1.4,3.1-3.1v-0.3c0-1.7-1.4-3.1-3.1-3.1h-0.3c-1.7,0-3.1,1.4-3.1,3.1v0.3     C59.2,68.3,60.6,69.7,62.3,69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00df94",
    d: "M74.7,69.7H75c1.7,0,3.1-1.4,3.1-3.1v-0.3c0-1.7-1.4-3.1-3.1-3.1h-0.3c-1.7,0-3.1,1.4-3.1,3.1v0.3     C71.6,68.3,73,69.7,74.7,69.7z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8421964837e1cddb4447dfc7e720abea.svg";
export { ForwardRef as ReactComponent };